import { useEffect, useState, useCallback } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useFirestore } from '../utils/firebase';
import { useAuth } from '../auth';

const useTenant = () => {
  const { user } = useAuth();
  const [tenant, setTenant] = useState();
  const database = useFirestore();

  const getTenant = useCallback(async () => {
    const tenantRef = doc(database, 'tenants', user.tenant.id);
    const userSnap = await getDoc(tenantRef);

    const tenant = userSnap.data();

    return tenant;
  }, [database, user.tenant.id]);

  useEffect(() => {
    async function fetchTenant() {
      setTenant(await getTenant());
    }
    fetchTenant();
  }, [getTenant]);

  return tenant;
};

export { useTenant };
